'use strict';

var _ = require('lodash');
var HistoryDrawerController = function HistoryDrawerController($scope, $filter, momentService, strategyConstants, historyDrawerService, historyDrawerCustomRenderersFactory, ruleNavigationService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function getGridHeaderCaption() {
    var headerFormat = _.replace($scope.headerFormat, /date\((\w+)\)/, function (m, propName) {
      return rmMomentFormat($scope.entityData[propName], 'DATE_USER_SETTINGS');
    });
    return _.template(headerFormat)($scope.entityData);
  }
  function getLocalization() {
    return {
      patterns: momentService.FORMAT
    };
  }
  $scope.getAdjustmentsHistoryDomain = function () {
    if ($scope.entityData.marketDemandId) {
      return 'MarketDemand';
    }
    if ($scope.entityData.serviceClassId) {
      return 'Service';
    }
    if ($scope.entityData.legCabinId || $scope.entityData.segmentClassId) {
      return 'Flight';
    }
  };
  $scope.adjustmentsHistoryDomain = $scope.getAdjustmentsHistoryDomain();
  $scope.appliedByRenderer = historyDrawerCustomRenderersFactory.appliedByRenderer($scope.history);
  historyDrawerService.getHistory($scope.entityData, $scope.adjustmentsHistoryDomain).then(function (history) {
    $scope.history = history;
    $scope.appliedByRenderer = historyDrawerCustomRenderersFactory.appliedByRenderer($scope.history);
    $scope.historyGridSettings.source = {
      localdata: $scope.history,
      datafields: [{
        name: 'date',
        type: 'date'
      }, {
        name: 'appliedBy',
        type: 'string'
      }, {
        name: 'fieldName',
        type: 'string'
      }, {
        name: 'valueWithSuffix',
        type: 'string'
      }]
    };
  });
  $scope.gridHeaderCaption = getGridHeaderCaption();
  $scope.gridId = 'adjustments-history-drawer-grid';
  var momentConfig = momentService.getConfig('ADJUSTMENTS_HISTORY_DATE_TIME');
  var momentFormat = 'DATE_TIME_USER_SETTINGS';
  $scope.historyGridSettings = {
    width: '100%',
    height: '100%',
    altrows: true,
    source: {},
    selectionmode: 'none',
    localization: getLocalization(),
    columns: [{
      text: 'Date',
      datafield: 'date',
      width: '25%',
      cellsalign: 'center',
      align: 'center',
      momentConfig: momentConfig,
      cellsformat: momentFormat
    }, {
      text: 'Applied By',
      datafield: 'appliedBy',
      width: '33%',
      align: 'center',
      cellsrenderer: $scope.appliedByRenderer
    }, {
      text: 'Field',
      datafield: 'fieldName',
      width: '30%',
      align: 'center'
    }, {
      text: 'Value',
      datafield: 'valueWithSuffix',
      width: '12%',
      cellsalign: 'center',
      align: 'center'
    }]
  };
  $scope.navigateToRules = function (technicalId) {
    ruleNavigationService.navigateToRules(technicalId);
  };
};
HistoryDrawerController.$inject = ['$scope', '$filter', 'MomentService', 'StrategyConstants', 'HistoryDrawerService', 'HistoryDrawerCustomRenderersFactory', 'RuleNavigationService'];
module.exports = HistoryDrawerController;